var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.777,
    height: 11.558,
    viewBox: "0 0 9.777 11.558",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.509,1.432A4.889,4.889,0,0,0,6.164,4.888c0,2.641,2.5,4.839,3.839,6.019.186.164.347.306.476.426a.842.842,0,0,0,1.147,0c.128-.12.289-.261.476-.426,1.342-1.18,3.839-3.377,3.839-6.019A4.857,4.857,0,0,0,14.509,1.432ZM11.655,10.4c-.191.168-.355.312-.491.439a.163.163,0,0,1-.222,0c-.136-.127-.3-.272-.491-.439-1.261-1.11-3.61-3.175-3.61-5.511a4.211,4.211,0,0,1,8.423,0C15.264,7.224,12.916,9.289,11.655,10.4Z",
    transform: "translate(-6.164 0)",
    fill: "#090909"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.734 2.55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.243,17.647A2.154,2.154,0,1,0,29.4,19.8,2.157,2.157,0,0,0,27.243,17.647Zm0,3.632A1.477,1.477,0,1,1,28.721,19.8,1.479,1.479,0,0,1,27.243,21.278Z",
    transform: "translate(-25.089 -17.647)",
    fill: "#090909"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.e22798cc8b5578c2bf6010407231930f.svg";
export { ForwardRef as ReactComponent };